<template minapp='mpx' xlang='wxml'>
  <es-popup
    show="{{show}}"
    position="{{position}}"
    class="custom-class"
    bind:close="close"
  >
    <view class="drawer-container" wx:style="{{customStyle}}">
      <view class="drawer-main custom-main">
        <slot />
      </view>
      <view
        class="header" 
        wx:style="{{navbarStyle}}"
      >
        <view>
          <slot name="left" wx:if="{{defaultNavLeft}}" />
          <view class="left-view" wx:else></view>
        </view>
        <view class="drawer-title">
          {{ title }}
        </view>
        <view
          bindtap='close'
        >
          <es-icon size="24" name="close-filled"></es-icon>
        </view>
      </view>
    </view>
  </es-popup>
  <!-- 用法举例 -->
  <!-- <drawer-bottom title="标题" showDefaultNav bind:close="close" /> -->
  <!-- <drawer-bottom title="标题" showDefaultNav bind:close="close">
    <template slot:left> 234 </template>
    主体内容
  </drawer-bottom> -->
</template>

<script>
import { createComponent } from '@didi/es-mpx-creator'

createComponent({
  externalClasses: [
    'custom-class',
    'custom-main',
    'custom-navbar',
    'custom-title',
  ],
  props: {
    title: String,
    showDefaultNav: {
      type: Boolean,
      value: true,
    },
    // 展示自定义的导航栏左侧
    defaultNavLeft: {
      type: Boolean,
      value: false,
    },
    defineLeft: {
      type: Boolean,
      value: false,
    },
    show: {
      type: Boolean,
      value: false,
    },
    leftArrow: Boolean,
    customStyle: null,
    navbarStyle: null,
    navbarClickLeft: null,
  },
  data() {
    return {
      position: 'bottom',
    }
  },
  methods: {
    handleClick() {},
    close() {
      this.$trigger('close')
    },
  },
  // 组件生命周期函数-在组件布局完成后执行)
  created() {},
})
</script>

<style lang="stylus" scoped>
  .drawer-container {
    // width: 100vw;
    height: 50vh;
    // margin-top: 50vh;
    background: #ffffff;
    border-radius: 16px 16px 0 0;
    display: flex;
    flex-direction: column;
    position: relative;

    .header {
      position: fixed;
      width: 100%
      height: 60px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 20px;
      box-sizing: border-box;
      background: #ffffff;
      border-radius: 16px 16px 0 0;
    }
  }

  .es-navbar {
    background-color: #ffffff;
    flex: 0 0 60px;
    width: 100%;
  }

  .left-view {
    width: 24px;
    height: 20px;
  }

  .drawer-title {
    font-size: 18px;
    font-weight: 700;
  }

  .drawer-main {
    flex: 1;
    overflow: auto;
    width: 100%;
    padding-top: 60px;
  }
</style>
<script name="json">
module.exports = {
  component: true,
  usingComponents: {
    'es-navbar': '../navbar',
    'es-popup': '../popup',
    'es-icon': '../icon',
  },
}
</script>
